import MapService from "~/services/MapService"

export default function({ $api, $store }, inject) {
  const map = new MapService($api, $store)
  inject("map", map)
}
